module.exports = __webpack_public_path__ + "assets/img/mecha-btn-06b9ff38.png";